import {
    EVENT,
} from '@constants/resources';
import Form from '@appComponents/ReduxFormControls';
import {GetStatusesForDropdown, GetDuration, GetDurationAndMatch} from '@graphql/reports/query';
import {UpdateDuration} from '@graphql/reports/mutation';
import * as messages from '@constants/messages';
import MatchDurationInfo from '@modules/events/views/MatchDurationInfo';

import validatorSetDuration from './validatorSetDuration';

export default function SetDurationModel({duration = null}) {
    return {
        entityLabel: 'duration',
        formName: 'duration',
        resources: EVENT,
        title: ()=> '',
        validate: validatorSetDuration,
        fields: {
            info_message: {
                props: {
                    component: MatchDurationInfo,
                    label: '',
                    name: 'info_message',
                },
            },
            duration: {
                props: {
                    component: Form.SemanticInput,
                    label: 'Duration',
                    labelDescription: {content: 'min'},
                    name: 'duration',
                    required: true,
                    type: 'number',
                    precision: 1,
                    min: 0.1,
                    step: '0.1',
                    defaultValue: duration,
                },
            },
        },
        messages: {
            boxName: {
                delete: 'eventsIndex',
                success: 'event',
                error: 'event',
            },
            text: messages,
        },
        mutation: {
            createEntity: UpdateDuration,
            deleteEntity: UpdateDuration,
        },
        query: {
            getEntity: GetDuration,
            getOptions: GetStatusesForDropdown,
        },
        mutationOptions: {
            create: {
                refetchQueries: [GetDurationAndMatch],
            },
        },
    };
}
